// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {findMatchingKey} from '../../shared/services/claim-shared-helper';

export const updateGoodsInstallationVat = (key, options) => ({
    goodsInstallationVat: findMatchingKey(key, options),
    type: actions.UPDATE_CLAIM_BATTERY_GOODS_INSTALLATION_VAT
});



// WEBPACK FOOTER //
// ./src/claim/battery/action-creators/update-goods-installation-vat.js